import {
    DEALERSUMMARYEXCELPDFFILE_FAILED,
    DEALERSUMMARYEXCELPDFFILE_SUCCESS,
    RESET_DEALERSUMMARYEXCELPDFFILE,
    LOADING_DEALERSUMMARYEXCELPDFFILE,
    NETWORK_ERROR_DEALERSUMMARYEXCELPDFFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";

const resetDealerSummaryExcelPdfFileList = () => {
    return { type: RESET_DEALERSUMMARYEXCELPDFFILE };
};

const dealerSummaryExcelPdfFile = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERSUMMARYEXCELPDFFILE });
    await dealerServices
        .post("summaryExcelPdfFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerSummaryExcelPdfFilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerSummaryExcelPdfFileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERSUMMARYEXCELPDFFILE,
                payload: err
            });
        });
};

function dealerSummaryExcelPdfFilesuccess(data) {
    return {
        type: DEALERSUMMARYEXCELPDFFILE_SUCCESS,
        payload: data
    };
}
function dealerSummaryExcelPdfFileFailed(data) {
    return {
        type: DEALERSUMMARYEXCELPDFFILE_FAILED,
        payload: data
    };
}

export { resetDealerSummaryExcelPdfFileList, dealerSummaryExcelPdfFile }
